<template>
  <generic-container
    class="ui tab segment"
    data-tab="backups"
    :title="$t('backups')"
    icon="history"
    :show_plus="true"
    :searchable="true"
    @add="add"
    @filter="filter"
  >
    <div class="ui selection divided list">
      <div
        class="item"
        v-for="(bk, index) in $props.project.ngn_project_snapshots"
        :key="index"
        v-on:click="restore(bk, index)"
      >
        <div class="right floated buttons">
          <div
            class="ui button red icon mini labeled"
            v-on:click.stop="remove(bk, index)"
          >
            <i class="trash icon"></i>
            {{ $t("delete") }}
          </div>
        </div>
        <img class="ui avatar image" src="/images/icons/backup.png" />
        <div class="content">
          <a class="header">{{ bk.snapshot_comment }}</a>
          <div class="description">
            {{ bk.create_date | fromNow }} |
            <small>{{
              bk.create_date | formatDate(enterprise_setup.detailed_date_format)
            }}</small>
          </div>
          <div class="description"></div>
        </div>
      </div>
    </div>
  </generic-container>
</template>

<script>
import { local_api, error_toast, enterprise_setup } from "@/utils";
import GenericContainer from "@/components/GenericContainer";
import filters from "@/filters";
import { success_toast } from "../../../utils";

export default {
  name: "BackupManagement",
  filters: filters,
  props: { project: Object },
  components: {
    GenericContainer,
  },
  data() {
    return {
      all_backups: [],
      proj: {},
    };
  },
  created() {
    this.proj = this.$props.project;
  },
  computed: {
    enterprise_setup() {
      return enterprise_setup(this);
    },
  },
  methods: {
    add() {
      let vm = this;
      this.$alertify.prompt(this.$t("snapshot comment"), "", function(
        $element,
        comment,
      ) {
        local_api(vm, "post", "/ngine_composer/project/do-snapshot", {
          u: vm.$props.project.uuid,
          c: comment,
        })
          .then((snapshot) => {
            vm.$props.project.ngn_project_snapshots.push(snapshot);
          })
          .catch((err) => {
            error_toast(err);
          });
      });
    },
    remove(bk, index) {
      let vm = this;
      this.$alertify.confirm(
        this.$t("are you sure to remove backup?"),
        function() {
          local_api(vm, "post", "/ngine_composer/project/remove-snapshot", {
            u: bk.uuid,
          })
            .then(() => {
              vm.$props.project.ngn_project_snapshots.splice(index, 1);
            })
            .catch((err) => {
              error_toast(err);
            });
        },
      );
    },
    restore(bk) {
      let vm = this;
      this.$alertify.confirm(
        this.$t("are you sure to restore this backup?"),
        function() {
          local_api(vm, "post", "/ngine_composer/project/do-restore", {
            u: bk.uuid,
          })
            .then(() => {
              success_toast(vm.$t("restoration finished"));
              location.reload();
            })
            .catch((err) => {
              error_toast(err);
            });
        },
      );
    },
    filter(query) {
      if (!query) this.$props.project.ngn_project_snapshots = this.all_backups;
      else
        this.$props.project.ngn_project_snapshots = this.all_backups.filter(
          (n) => n.snapshot_comment.toUpperCase().includes(query.toUpperCase()),
        );
    },
  },
  mounted() {
    let vm = this;
    setTimeout(function() {
      vm.$props.project.ngn_project_snapshots =
        vm.$props.project.ngn_project_snapshots || [];
      vm.all_backups = [...vm.$props.project.ngn_project_snapshots];
    }, 500);
  },
  watch: {},
};
</script>
